document.querySelectorAll('.glance__wrapper').forEach((glance) => {
    const titles = Array.from(glance.querySelectorAll('.glance__title'))
    const images = Array.from(glance.querySelectorAll('.glance__image-wrapper'))
    const groups = Array.from(glance.querySelectorAll('.glance__group'))

    const activateItem = (index) => {
        if (!images[index]) return

        titles.forEach((title, titleIndex) => {
            title.classList.toggle('active', titleIndex === index)
        })
        images.forEach((image, imageIndex) => {
            image.classList.toggle('active', imageIndex === index)
        })
    }

    titles.forEach((title, index) => {
        title.addEventListener('mouseenter', () => activateItem(index))
        title.addEventListener('click', () => activateItem(index))
        const link = title.closest('a')
        link?.addEventListener('focus', () => activateItem(index))
    })

    // Keep the source homepage's reveal timing without depending on section order.
    const reveal = () => {
        if (glance.getBoundingClientRect().top >= window.innerHeight * 0.75 + 80) return

        glance.classList.add('active')
        groups.forEach((group, index) => {
            setTimeout(() => group.classList.add('active'), 100 * index)
        })
        window.removeEventListener('scroll', reveal)
        window.removeEventListener('resize', reveal)
    }

    window.addEventListener('scroll', reveal, { passive: true })
    window.addEventListener('resize', reveal)
    reveal()
})
